module.exports = __webpack_public_path__ + "img/loveInvitationText.31550f7a.jpg";